import { AirPods } from "../imagesmobile";
import { useImage } from "../hooks";

const AirpodsArray = () => {
  const [AA0, AA0S] = useImage(AirPods[0]);
  const [AA1, AA1S] = useImage(AirPods[1]);
  const [AA2, AA2S] = useImage(AirPods[2]);
  const [AA3, AA3S] = useImage(AirPods[3]);
  const [AA4, AA4S] = useImage(AirPods[4]);
  const [AA5, AA5S] = useImage(AirPods[5]);
  const [AA6, AA6S] = useImage(AirPods[6]);
  const [AA7, AA7S] = useImage(AirPods[7]);
  const [AA8, AA8S] = useImage(AirPods[8]);
  const [AA9, AA9S] = useImage(AirPods[9]);

  const [AA10, AA10S] = useImage(AirPods[10]);
  const [AA11, AA11S] = useImage(AirPods[11]);
  const [AA12, AA12S] = useImage(AirPods[12]);
  const [AA13, AA13S] = useImage(AirPods[13]);
  const [AA14, AA14S] = useImage(AirPods[14]);
  const [AA15, AA15S] = useImage(AirPods[15]);
  const [AA16, AA16S] = useImage(AirPods[16]);
  const [AA17, AA17S] = useImage(AirPods[17]);
  const [AA18, AA18S] = useImage(AirPods[18]);
  const [AA19, AA19S] = useImage(AirPods[19]);

  const [AA20, AA20S] = useImage(AirPods[20]);
  const [AA21, AA21S] = useImage(AirPods[21]);
  const [AA22, AA22S] = useImage(AirPods[22]);
  const [AA23, AA23S] = useImage(AirPods[23]);
  const [AA24, AA24S] = useImage(AirPods[24]);
  const [AA25, AA25S] = useImage(AirPods[25]);
  const [AA26, AA26S] = useImage(AirPods[26]);
  const [AA27, AA27S] = useImage(AirPods[27]);
  const [AA28, AA28S] = useImage(AirPods[28]);
  const [AA29, AA29S] = useImage(AirPods[29]);

  const [AA30, AA30S] = useImage(AirPods[30]);
  const [AA31, AA31S] = useImage(AirPods[31]);
  const [AA32, AA32S] = useImage(AirPods[32]);
  const [AA33, AA33S] = useImage(AirPods[33]);
  const [AA34, AA34S] = useImage(AirPods[34]);
  const [AA35, AA35S] = useImage(AirPods[35]);
  const [AA36, AA36S] = useImage(AirPods[36]);
  const [AA37, AA37S] = useImage(AirPods[37]);
  const [AA38, AA38S] = useImage(AirPods[38]);
  const [AA39, AA39S] = useImage(AirPods[39]);

  const [AA40, AA40S] = useImage(AirPods[40]);
  const [AA41, AA41S] = useImage(AirPods[41]);
  const [AA42, AA42S] = useImage(AirPods[42]);
  const [AA43, AA43S] = useImage(AirPods[43]);
  const [AA44, AA44S] = useImage(AirPods[44]);
  const [AA45, AA45S] = useImage(AirPods[45]);
  const [AA46, AA46S] = useImage(AirPods[46]);
  const [AA47, AA47S] = useImage(AirPods[47]);
  const [AA48, AA48S] = useImage(AirPods[48]);
  const [AA49, AA49S] = useImage(AirPods[49]);

  const [AA50, AA50S] = useImage(AirPods[50]);
  const [AA51, AA51S] = useImage(AirPods[51]);
  const [AA52, AA52S] = useImage(AirPods[52]);
  const [AA53, AA53S] = useImage(AirPods[53]);
  const [AA54, AA54S] = useImage(AirPods[54]);
  const [AA55, AA55S] = useImage(AirPods[55]);
  const [AA56, AA56S] = useImage(AirPods[56]);
  const [AA57, AA57S] = useImage(AirPods[57]);
  const [AA58, AA58S] = useImage(AirPods[58]);
  const [AA59, AA59S] = useImage(AirPods[59]);

  const [AA60, AA60S] = useImage(AirPods[60]);
  const [AA61, AA61S] = useImage(AirPods[61]);
  const [AA62, AA62S] = useImage(AirPods[62]);
  const [AA63, AA63S] = useImage(AirPods[63]);
  const [AA64, AA64S] = useImage(AirPods[64]);
  const [AA65, AA65S] = useImage(AirPods[65]);
  const [AA66, AA66S] = useImage(AirPods[66]);
  const [AA67, AA67S] = useImage(AirPods[67]);
  const [AA68, AA68S] = useImage(AirPods[68]);
  const [AA69, AA69S] = useImage(AirPods[69]);

  const [AA70, AA70S] = useImage(AirPods[70]);
  const [AA71, AA71S] = useImage(AirPods[71]);
  const [AA72, AA72S] = useImage(AirPods[72]);
  const [AA73, AA73S] = useImage(AirPods[73]);
  const [AA74, AA74S] = useImage(AirPods[74]);
  const [AA75, AA75S] = useImage(AirPods[75]);
  const [AA76, AA76S] = useImage(AirPods[76]);
  const [AA77, AA77S] = useImage(AirPods[77]);
  const [AA78, AA78S] = useImage(AirPods[78]);
  const [AA79, AA79S] = useImage(AirPods[79]);

  const [AA80, AA80S] = useImage(AirPods[80]);
  const [AA81, AA81S] = useImage(AirPods[81]);
  const [AA82, AA82S] = useImage(AirPods[82]);
  const [AA83, AA83S] = useImage(AirPods[83]);
  const [AA84, AA84S] = useImage(AirPods[84]);
  const [AA85, AA85S] = useImage(AirPods[85]);
  const [AA86, AA86S] = useImage(AirPods[86]);
  const [AA87, AA87S] = useImage(AirPods[87]);
  const [AA88, AA88S] = useImage(AirPods[88]);
  const [AA89, AA89S] = useImage(AirPods[89]);

  const [AA90, AA90S] = useImage(AirPods[90]);
  const [AA91, AA91S] = useImage(AirPods[91]);
  const [AA92, AA92S] = useImage(AirPods[92]);
  const [AA93, AA93S] = useImage(AirPods[93]);
  const [AA94, AA94S] = useImage(AirPods[94]);
  const [AA95, AA95S] = useImage(AirPods[95]);
  const [AA96, AA96S] = useImage(AirPods[96]);
  const [AA97, AA97S] = useImage(AirPods[97]);
  const [AA98, AA98S] = useImage(AirPods[98]);
  const [AA99, AA99S] = useImage(AirPods[99]);

  const [AA100, AA100S] = useImage(AirPods[100]);
  const [AA101, AA101S] = useImage(AirPods[101]);
  const [AA102, AA102S] = useImage(AirPods[102]);
  const [AA103, AA103S] = useImage(AirPods[103]);
  const [AA104, AA104S] = useImage(AirPods[104]);
  const [AA105, AA105S] = useImage(AirPods[105]);
  const [AA106, AA106S] = useImage(AirPods[106]);
  const [AA107, AA107S] = useImage(AirPods[107]);
  const [AA108, AA108S] = useImage(AirPods[108]);
  const [AA109, AA109S] = useImage(AirPods[109]);

  const [AA110, AA110S] = useImage(AirPods[110]);
  const [AA111, AA111S] = useImage(AirPods[111]);
  const [AA112, AA112S] = useImage(AirPods[112]);
  const [AA113, AA113S] = useImage(AirPods[113]);
  const [AA114, AA114S] = useImage(AirPods[114]);
  const [AA115, AA115S] = useImage(AirPods[115]);
  const [AA116, AA116S] = useImage(AirPods[116]);
  const [AA117, AA117S] = useImage(AirPods[117]);
  const [AA118, AA118S] = useImage(AirPods[118]);
  const [AA119, AA119S] = useImage(AirPods[119]);

  const [AA120, AA120S] = useImage(AirPods[120]);
  const [AA121, AA121S] = useImage(AirPods[121]);
  const [AA122, AA122S] = useImage(AirPods[122]);
  const [AA123, AA123S] = useImage(AirPods[123]);
  const [AA124, AA124S] = useImage(AirPods[124]);
  const [AA125, AA125S] = useImage(AirPods[125]);
  const [AA126, AA126S] = useImage(AirPods[126]);
  const [AA127, AA127S] = useImage(AirPods[127]);
  const [AA128, AA128S] = useImage(AirPods[128]);
  const [AA129, AA129S] = useImage(AirPods[129]);

  const [AA130, AA130S] = useImage(AirPods[130]);
  const [AA131, AA131S] = useImage(AirPods[131]);
  const [AA132, AA132S] = useImage(AirPods[132]);
  const [AA133, AA133S] = useImage(AirPods[133]);
  const [AA134, AA134S] = useImage(AirPods[134]);
  const [AA135, AA135S] = useImage(AirPods[135]);
  const [AA136, AA136S] = useImage(AirPods[136]);
  const [AA137, AA137S] = useImage(AirPods[137]);
  const [AA138, AA138S] = useImage(AirPods[138]);
  const [AA139, AA139S] = useImage(AirPods[139]);

  const [AA140, AA140S] = useImage(AirPods[140]);
  const [AA141, AA141S] = useImage(AirPods[141]);
  const [AA142, AA142S] = useImage(AirPods[142]);
  const [AA143, AA143S] = useImage(AirPods[143]);
  const [AA144, AA144S] = useImage(AirPods[144]);
  const [AA145, AA145S] = useImage(AirPods[145]);
  const [AA146, AA146S] = useImage(AirPods[146]);
  const [AA147, AA147S] = useImage(AirPods[147]);
  const [AA148, AA148S] = useImage(AirPods[148]);
  const [AA149, AA149S] = useImage(AirPods[149]);

  const [AA150, AA150S] = useImage(AirPods[150]);
  const [AA151, AA151S] = useImage(AirPods[151]);
  const [AA152, AA152S] = useImage(AirPods[152]);
  const [AA153, AA153S] = useImage(AirPods[153]);
  const [AA154, AA154S] = useImage(AirPods[154]);
  const [AA155, AA155S] = useImage(AirPods[155]);
  const [AA156, AA156S] = useImage(AirPods[156]);
  const [AA157, AA157S] = useImage(AirPods[157]);
  const [AA158, AA158S] = useImage(AirPods[158]);
  const [AA159, AA159S] = useImage(AirPods[159]);

  const [AA160, AA160S] = useImage(AirPods[160]);
  const [AA161, AA161S] = useImage(AirPods[161]);
  const [AA162, AA162S] = useImage(AirPods[162]);
  const [AA163, AA163S] = useImage(AirPods[163]);
  const [AA164, AA164S] = useImage(AirPods[164]);
  const [AA165, AA165S] = useImage(AirPods[165]);
  const [AA166, AA166S] = useImage(AirPods[166]);
  const [AA167, AA167S] = useImage(AirPods[167]);
  const [AA168, AA168S] = useImage(AirPods[168]);
  const [AA169, AA169S] = useImage(AirPods[169]);

  const [AA170, AA170S] = useImage(AirPods[170]);
  const [AA171, AA171S] = useImage(AirPods[171]);
  const [AA172, AA172S] = useImage(AirPods[172]);
  const [AA173, AA173S] = useImage(AirPods[173]);
  const [AA174, AA174S] = useImage(AirPods[174]);
  const [AA175, AA175S] = useImage(AirPods[175]);
  const [AA176, AA176S] = useImage(AirPods[176]);

  const newImages = Array.of(
    [AA0, AA0S],
    [AA1, AA1S],
    [AA2, AA2S],
    [AA3, AA3S],
    [AA4, AA4S],
    [AA5, AA5S],
    [AA6, AA6S],
    [AA7, AA7S],
    [AA8, AA8S],
    [AA9, AA9S],
    [AA10, AA10S],
    [AA11, AA11S],
    [AA12, AA12S],
    [AA13, AA13S],
    [AA14, AA14S],
    [AA15, AA15S],
    [AA16, AA16S],
    [AA17, AA17S],
    [AA18, AA18S],
    [AA19, AA19S],
    [AA20, AA20S],
    [AA21, AA21S],
    [AA22, AA22S],
    [AA23, AA23S],
    [AA24, AA24S],
    [AA25, AA25S],
    [AA26, AA26S],
    [AA27, AA27S],
    [AA28, AA28S],
    [AA29, AA29S],

    [AA30, AA30S],
    [AA31, AA31S],
    [AA32, AA32S],
    [AA33, AA33S],
    [AA34, AA34S],
    [AA35, AA35S],
    [AA36, AA36S],
    [AA37, AA37S],
    [AA38, AA38S],
    [AA39, AA39S],

    [AA40, AA40S],
    [AA41, AA41S],
    [AA42, AA42S],
    [AA43, AA43S],
    [AA44, AA44S],
    [AA45, AA45S],
    [AA46, AA46S],
    [AA47, AA47S],
    [AA48, AA48S],
    [AA49, AA49S],

    [AA50, AA50S],
    [AA51, AA51S],
    [AA52, AA52S],
    [AA53, AA53S],
    [AA54, AA54S],
    [AA55, AA55S],
    [AA56, AA56S],
    [AA57, AA57S],
    [AA58, AA58S],
    [AA59, AA59S],

    [AA60, AA60S],
    [AA61, AA61S],
    [AA62, AA62S],
    [AA63, AA63S],
    [AA64, AA64S],
    [AA65, AA65S],
    [AA66, AA66S],
    [AA67, AA67S],
    [AA68, AA68S],
    [AA69, AA69S],

    [AA70, AA70S],
    [AA71, AA71S],
    [AA72, AA72S],
    [AA73, AA73S],
    [AA74, AA74S],
    [AA75, AA75S],
    [AA76, AA76S],
    [AA77, AA77S],
    [AA78, AA78S],
    [AA79, AA79S],

    [AA80, AA80S],
    [AA81, AA81S],
    [AA82, AA82S],
    [AA83, AA83S],
    [AA84, AA84S],
    [AA85, AA85S],
    [AA86, AA86S],
    [AA87, AA87S],
    [AA88, AA88S],
    [AA89, AA89S],

    [AA90, AA90S],
    [AA91, AA91S],
    [AA92, AA92S],
    [AA93, AA93S],
    [AA94, AA94S],
    [AA95, AA95S],
    [AA96, AA96S],
    [AA97, AA97S],
    [AA98, AA98S],
    [AA99, AA99S],

    [AA100, AA100S],
    [AA101, AA101S],
    [AA102, AA102S],
    [AA103, AA103S],
    [AA104, AA104S],
    [AA105, AA105S],
    [AA106, AA106S],
    [AA107, AA107S],
    [AA108, AA108S],
    [AA109, AA109S],

    [AA110, AA110S],
    [AA111, AA111S],
    [AA112, AA112S],
    [AA113, AA113S],
    [AA114, AA114S],
    [AA115, AA115S],
    [AA116, AA116S],
    [AA117, AA117S],
    [AA118, AA118S],
    [AA119, AA119S],

    [AA120, AA120S],
    [AA121, AA121S],
    [AA122, AA122S],
    [AA123, AA123S],
    [AA124, AA124S],
    [AA125, AA125S],
    [AA126, AA126S],
    [AA127, AA127S],
    [AA128, AA128S],
    [AA129, AA129S],

    [AA130, AA130S],
    [AA131, AA131S],
    [AA132, AA132S],
    [AA133, AA133S],
    [AA134, AA134S],
    [AA135, AA135S],
    [AA136, AA136S],
    [AA137, AA137S],
    [AA138, AA138S],
    [AA139, AA139S],

    [AA140, AA140S],
    [AA141, AA141S],
    [AA142, AA142S],
    [AA143, AA143S],
    [AA144, AA144S],
    [AA145, AA145S],
    [AA146, AA146S],
    [AA147, AA147S],
    [AA148, AA148S],
    [AA149, AA149S],

    [AA150, AA150S],
    [AA151, AA151S],
    [AA152, AA152S],
    [AA153, AA153S],
    [AA154, AA154S],
    [AA155, AA155S],
    [AA156, AA156S],
    [AA157, AA157S],
    [AA158, AA158S],
    [AA159, AA159S],

    [AA160, AA160S],
    [AA161, AA161S],
    [AA162, AA162S],
    [AA163, AA163S],
    [AA164, AA164S],
    [AA165, AA165S],
    [AA166, AA166S],
    [AA167, AA167S],
    [AA168, AA168S],
    [AA169, AA169S],

    [AA170, AA170S],
    [AA171, AA171S],
    [AA172, AA172S],
    [AA173, AA173S],
    [AA174, AA174S],
    [AA175, AA175S],
    [AA176, AA176S]
  );
  return newImages;
};

export default AirpodsArray;
